import {Action} from '@ngrx/store';

import {GroupInvitation, OrgInvitation, RemoveGroupUser} from '../../../shared';
import {OrganizationUser} from '../../../afb-api/models/organization-user';

export const REQUEST_ORG_USER_LIST = '[User] Request Organization User List';

export const REQUEST_ORG_USER_LIST_COMPLETE = '[User] Request Organization User List Complete';
export const REQUEST_SELF_ORG_INFO_COMPLETE = '[User] Request Self Organization Info Complete';

export const INVITE_ORG = '[User] Invite Organization';
export const INVITE_ORG_SUCCESS = '[User] Invite Organization Success';
export const INVITE_ORG_FAIL = '[User] Invite Organization Fail';

export const INVITE_GROUP = '[User] Invite Group';
export const INVITE_GROUP_SUCCESS = '[User] Invite Group Success';
export const INVITE_GROUP_FAIL = '[User] Invite Group Fail';

export const REMOVE_FROM_ORG = '[User] Remove From Organization';
export const REMOVE_FROM_ORG_SUCCESS = '[User] Remove From Organization Success';
export const REMOVE_FROM_ORG_FAIL = '[User] Remove From Organization Fail';

export const REMOVE_FROM_GROUP = '[User] Remove From Group';
export const REMOVE_FROM_GROUP_SUCCESS = '[User] Remove From Group Success';
export const REMOVE_FROM_GROUP_FAIL = '[User] Remove From Group Fail';

export const REMOVE_FROM_ALL_GROUP = '[User] Remove From All Group';
export const REMOVE_FROM_ALL_GROUP_SUCCESS = '[User] Remove From All Group Success';
export const REMOVE_FROM_ALL_GROUP_FAIL = '[User] Remove From All Group Fail';

export const SET_ORG_USER_ACCESS = '[User] Set Organization User Access';
export const SET_ORG_USER_ACCESS_SUCCESS = '[User] Set Organization User Access Success';
export const SET_ORG_USER_ACCESS_FAIL = '[User] Set Organization User Access Fail';

export const SET_GROUP_USER_ACCESS = '[User] Set Group User Access';
export const SET_GROUP_USER_ACCESS_SUCCESS = '[User] Set Group User Access Success';
export const SET_GROUP_USER_ACCESS_FAIL = '[User] Set Group User Access Fail';

// Loadings
export const START_RETRIEVING_USER_LIST = '[User] Start Retrieving User List';
export const START_INVITING_ORG = '[User] Start Inviting Organization';
export const START_INVITING_GROUP = '[User] Start Inviting Group';
export const START_REMOVING_FROM_ORG = '[User] Start Removing From Organization';
export const START_REMOVING_FROM_GROUP = '[User] Start Removing From Group';
export const START_SETTING_ORG_ACCESS = '[User] Start Setting Organization Access';
export const START_SETTING_GROUP_ACCESS = '[User] Start Setting Group Access';

export class RequestOrgUserListAction implements Action {
  readonly type = REQUEST_ORG_USER_LIST;

  // org_token
  constructor(public payload: string) {
  }
}

export class RequestOrgUserListCompleteAction implements Action {
  readonly type = REQUEST_ORG_USER_LIST_COMPLETE;

  constructor(public payload: OrganizationUser[]) {
  }
}

export class RequestSelfOrgInfoCompleteAction implements Action {
  readonly type = REQUEST_SELF_ORG_INFO_COMPLETE;

  constructor(public payload: OrganizationUser) {
  }
}

// Invite Organization Action
export class InviteOrgAction implements Action {
  readonly type = INVITE_ORG;

  constructor(public payload: {
    orgToken: string,
    orgInvitationList: OrgInvitation[]
  }) {
  }
}

export class InviteOrgSuccessAction implements Action {
  readonly type = INVITE_ORG_SUCCESS;

  constructor() {
  }
}

export class InviteOrgFailAction implements Action {
  readonly type = INVITE_ORG_FAIL;

  constructor() {
  }
}

// Invite Group Action
export class InviteGroupAction implements Action {
  readonly type = INVITE_GROUP;

  constructor(public payload: {
    orgToken: string,
    groupInvitationList: GroupInvitation[]
  }) {
  }
}

export class InviteGroupSuccessAction implements Action {
  readonly type = INVITE_GROUP_SUCCESS;

  constructor() {
  }
}

export class InviteGroupFailAction implements Action {
  readonly type = INVITE_GROUP_FAIL;

  constructor() {
  }
}

// Remove Organization Actions
export class RemoveFromOrgAction implements Action {
  readonly type = REMOVE_FROM_ORG;

  constructor(public payload: {
    orgToken: string,
    userIdList: string[]
  }) {
  }
}

export class RemoveFromOrgSuccessAction implements Action {
  readonly type = REMOVE_FROM_ORG_SUCCESS;

  constructor() {
  }
}

export class RemoveFromOrgFailAction implements Action {
  readonly type = REMOVE_FROM_ORG_FAIL;

  constructor() {
  }
}

// Remove Group Actions
export class RemoveFromGroupAction implements Action {
  readonly type = REMOVE_FROM_GROUP;

  constructor(public payload: {
    orgToken: string,
    removeGroupUserList: RemoveGroupUser[]
  }) {
  }
}

export class RemoveFromGroupSuccessAction implements Action {
  readonly type = REMOVE_FROM_GROUP_SUCCESS;

  constructor() {
  }
}

export class RemoveFromGroupFailAction implements Action {
  readonly type = REMOVE_FROM_GROUP_FAIL;

  constructor() {
  }
}

// Remove Group Actions
export class RemoveFromAllGroupAction implements Action {
  readonly type = REMOVE_FROM_ALL_GROUP;

  constructor(public payload: {
    orgToken: string,
    orgUserList: OrganizationUser[]
  }) {
  }
}

export class RemoveFromAllGroupSuccessAction implements Action {
  readonly type = REMOVE_FROM_ALL_GROUP_SUCCESS;

  constructor() {
  }
}

export class RemoveFromAllGroupFailAction implements Action {
  readonly type = REMOVE_FROM_ALL_GROUP_FAIL;

  constructor() {
  }
}

export class SetOrgUserAccessAction implements Action {
  readonly type = SET_ORG_USER_ACCESS;

  constructor(public payload: {
    orgToken: string,
    inviteAdminList: string[],
    removeUserList: OrganizationUser[],
    removeAllGroupList: OrganizationUser[],
    removePendingAdminList: OrganizationUser[],
    removePendingMemberList: OrganizationUser[]
  }) {
  }
}

export class SetOrgUserAccessSuccessAction implements Action {
  readonly type = SET_ORG_USER_ACCESS_SUCCESS;

  constructor() {
  }
}

export class SetOrgUserAccessFailAction implements Action {
  readonly type = SET_ORG_USER_ACCESS_FAIL;

  constructor() {
  }
}

export class SetGroupUserAccessAction implements Action {
  readonly type = SET_GROUP_USER_ACCESS;

  constructor(public payload: {
    orgToken: string,
    inviteMemberList: string[],
    removeMemberList: OrganizationUser[],
    addMemberList: OrganizationUser[],
    groupId: string
  }) {
  }
}

export class SetGroupUserAccessSuccessAction implements Action {
  readonly type = SET_GROUP_USER_ACCESS_SUCCESS;

  constructor() {
  }
}

export class SetGroupUserAccessFailAction implements Action {
  readonly type = SET_GROUP_USER_ACCESS_FAIL;

  constructor() {
  }
}

// Loading Actions
export class StartRetrievingUserListAction implements Action {
  readonly type = START_RETRIEVING_USER_LIST;

  constructor() {
  }
}

export class StartInvitingOrgAction implements Action {
  readonly type = START_INVITING_ORG;

  constructor() {
  }
}

export class StartInvitingGroupAction implements Action {
  readonly type = START_INVITING_GROUP;

  constructor() {
  }
}

export class StartRemovingFromOrgAction implements Action {
  readonly type = START_REMOVING_FROM_ORG;

  constructor() {
  }
}

export class StartRemovingFromGroupAction implements Action {
  readonly type = START_REMOVING_FROM_GROUP;

  constructor() {
  }
}

export class StartSettingOrgAccessAction implements Action {
  readonly type = START_SETTING_ORG_ACCESS;

  constructor() {
  }
}

export class StartSettingGroupAccessAction implements Action {
  readonly type = START_SETTING_GROUP_ACCESS;

  constructor() {
  }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
  = RequestOrgUserListAction
  | RequestOrgUserListCompleteAction
  | RequestSelfOrgInfoCompleteAction
  | InviteOrgAction
  | InviteOrgSuccessAction
  | InviteOrgFailAction
  | InviteGroupAction
  | InviteGroupSuccessAction
  | InviteGroupFailAction
  | RemoveFromOrgAction
  | RemoveFromOrgSuccessAction
  | RemoveFromOrgFailAction
  | RemoveFromGroupAction
  | RemoveFromGroupSuccessAction
  | RemoveFromGroupFailAction
  | SetOrgUserAccessAction
  | SetOrgUserAccessSuccessAction
  | SetOrgUserAccessFailAction
  | SetGroupUserAccessAction
  | SetGroupUserAccessSuccessAction
  | SetGroupUserAccessFailAction
  | StartRetrievingUserListAction
  | StartInvitingOrgAction
  | StartInvitingGroupAction
  | StartRemovingFromOrgAction
  | StartRemovingFromGroupAction
  | StartSettingOrgAccessAction
  | StartSettingGroupAccessAction;
